import {
    getInputsForBroker,
} from "./inputReader";
import {calcAjaxCall} from "./ajax";
import containerElement from "../helpers/containerElement";

const initOilCalculator = () => {
    if (!document.querySelector('.oilcalculator') || document.querySelector('.is-free-membership')) {
        return;
    }

    // add event listeners:
    let inputs = document.querySelectorAll(['.oilcalculator__input-section input', '.oilcalculator__input-section select']);
    inputs.forEach(c => {
        c.addEventListener('change', onInputChange);
    });


    document.querySelectorAll('.oil-do-calculate').forEach((el, index) => {
        el.addEventListener('click', oilCalculate);
    });

    document.querySelectorAll('.oil-do-share-deal').forEach((el, index) => {
        el.addEventListener('click', oilShareDeal);
    });

    document.querySelectorAll('.oil-first-select-1').forEach((el, index) => {
        el.addEventListener('change', duplicateMarket);
    });
    document.querySelectorAll('.oil-first-select-2').forEach((el, index) => {
        el.addEventListener('change', duplicateMarket);
    });

}

const duplicateMarket = (e) => {
    const containerEl = containerElement(e.target);

    if (e.target.className.indexOf('oil-first-select-1') >= 0) {
        containerEl.querySelector('.oil-second-select-1').value = e.target.value;
        containerEl.querySelector('.oil-second-select-1').dispatchEvent(new Event('change'));
    } else if (e.target.className.indexOf('oil-first-select-2') >= 0) {
        containerEl.querySelector('.oil-second-select-2').value = e.target.value;
        containerEl.querySelector('.oil-second-select-2').dispatchEvent(new Event('change'));
    }
}


const oilSetLastCalc = (e, val) => {
    let container = null;
    if(typeof e ==='object' && e.target) {
        container = containerElement(e.target);
    } else {
        container = e;
    }

    container.setAttribute('data-last-calc', val);
}

const oilGetLastCalc = (e) => {
    let container = containerElement(e.target);
    const ret = container.getAttribute('data-last-calc');
    return ret;
}


const oilShareDeal = (e) => {
    const lastCalc = oilGetLastCalc(e);
    if (!lastCalc) {
        alert('Plese click the calculate button first.');
        return;
    }

    const containerEl = containerElement(e.target);
    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    if(!brokerInputs['1']['broker'] || !brokerInputs['1']['broker'] ) {
        alert('Please enter the brokers before sharing.');
        return;
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    const resFetch = calcAjaxCall(containerEl, lastCalc, 'share_deal');

    resFetch.then((result) => {
        const output = result.json();
        //alert('Deal shared!');

        containerEl.querySelector('.deal-info-msg').innerHTML = 'Thank you for sharing this Deal!';
        }
    );
}

/***
 * Main calc function, re-renders all outputs in a single step
 */
const oilCalculate = (e) => {
    const containerEl = containerElement(e.target);

    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    if (swapTypes[0] === 'points' && swapTypes[1] === 'points') {
        updateOutputsSwapTypePointsPoints(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'points') {
        updateOutputsSwapTypePercentPoints(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypePointsPercent(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypePercentPercent(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'points') {
        updateOutputsSwapTypeUsdPoints(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypePointsUsd(containerEl);
    } else if (swapTypes[0] === 'percent' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypePercentUsd(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'percent') {
        updateOutputsSwapTypeUsdPercent(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypeUsdUsd(containerEl);
    } else {
        console.error('Cannot update outputs - scenario not implemented');
    }
}

const printOutputs = (containerEl, outputJsonResp) => {
    outputJsonResp.then(output => {

        // console.log('output:');
        // console.log(output);

        const cssPrefix = '.oilcalculator__output-scenario ';
        setOutputField(containerEl, cssPrefix, 'fund-broker-1', 'input[type=text]', output['fund_broker1']);
        setOutputField(containerEl, cssPrefix, 'fund-broker-2', 'input[type=text]', output['fund_broker2']);
        setOutputField(containerEl, cssPrefix, 'trade-cost-clears-in', 'input[type=text]', output['trade_cost_clears_in']);
        setOutputField(containerEl, cssPrefix, 'multiplier', 'input[type=text]', output['multiplier']);
        setOutputField(containerEl, cssPrefix, 'monthly-return', 'input[type=text]', output['monthly_return']);
        setOutputField(containerEl, cssPrefix, 'trade-size-1', 'input[type=text]', output['trade_size1']);
        setOutputField(containerEl, cssPrefix, 'trade-size-2', 'input[type=text]', output['trade_size2']);
        //setOutputField(containerEl,cssPrefix, 'fund-broker-1-currency', '', 'GBP');
        //setOutputField(containerEl,cssPrefix, 'fund-broker-2-currency', '', 'GBP');
        if (containerEl.querySelector('.oil-div-console')) {
            containerEl.querySelector('.oil-div-console').innerText = JSON.stringify(output['iv']);
        }
    });
}

const updateOutputsSwapTypePointsPoints = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'points-points');
    oilSetLastCalc(containerEl, 'points-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentPoints = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'percent-points');
    oilSetLastCalc(containerEl, 'percent-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePointsPercent = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'points-percent');
    oilSetLastCalc(containerEl, 'points-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePercentPercent = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'percent-percent');
    oilSetLastCalc(containerEl, 'percent-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypeUsdPoints = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'usd-points');
    oilSetLastCalc(containerEl, 'usd-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypePointsUsd = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'points-usd');
    oilSetLastCalc(containerEl, 'points-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}


const updateOutputsSwapTypePercentUsd = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'percent-usd');
    oilSetLastCalc(containerEl, 'percent-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdPercent = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'usd-percent');
    oilSetLastCalc(containerEl, 'usd-percent');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdUsd = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'usd-usd');
    oilSetLastCalc(containerEl, 'usd-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const setOutputField = (containerEl, cssPrefix, fieldName, inputType, val) => {
    //console.log(fieldName);

    if (fieldName === 'monthly-return') {
        containerEl.querySelector(cssPrefix + ' .monthly-return ').innerHTML = val;
        return;
    }

    if (inputType) {
        containerEl.querySelector(cssPrefix + ' [data-field="' + fieldName + '"] ' + inputType).value = val;
        containerEl.querySelector(cssPrefix + ' [data-field="' + fieldName + '"] ' + inputType).dispatchEvent(new Event('change'));
    } else {
        containerEl.querySelector(cssPrefix + ' [data-label="' + fieldName + '"] ' + inputType).innerHTML = val;
    }
}

const onInputChange = (e) => {

    if (e.target.className.indexOf('select-input') >= 0) {
        return;
    }

    if (e.target.className.indexOf('excluded') >= 0) {
        return;
    }

    oilCalculate(e);
    //alert("Input changed");
}

initOilCalculator();
